import { toast } from 'react-toastify';

export const OPCOES_TOAST = {
     style: { backgroundColor: '#141414', color: 'white' },
     autoClose: 2000,
};

export const formatarParaSelect = (arr, concatRotulo = '')=>{
     const newArr = arr.map((ele)=>({
          label: `${Array.isArray(ele) ? ele[1] : ele} ${concatRotulo}`,
          value: Array.isArray(ele) ? ele[0] : ele,
          key: Array.isArray(ele) ? ele[0] : ele,
     }))
     return newArr;
}
export const formatarTelefone = (numero)=> {
     const ddd = numero.substring(0, 2);
     const celular = numero.substring(2, numero.length);

     return `(${ddd}) ${celular}`;
}

export const ToastErro = (erro)=> {
     toast.dark(
         erro, {
             type: 'error', toastId: 'ERRO'
         }
     )
 }